import { LatLng } from 'leaflet';
import { db } from '../DBUtils';
import { Story } from '../Story';

export type StoryQuery = {
	filter?: {
		id?: number[];
		title?: string;
		featured?: boolean;
		has_topics?: string[]; // topic slugs
		distance_from?: { location: LatLng; radius: number };
	};
	sort?: {
		distance_from?: LatLng;
		featured?: boolean;
	};
	limit?: number;
};

export type StoryList = {
	query?: StoryQuery;
	stories: Story[];
	success: boolean;
	reason?: string;
};

export class StoryFactory {
	public static getEmpty() {
		const empty_set: StoryList = {
			stories: [],
			success: true,
		};
		return empty_set;
	}

	public static async getAll() {
		return db.stories
			.toArray()
			.then(async (my_stories) => {
				let decorated = await Story.decorate(my_stories);
				let retval: StoryList = {
					stories: decorated,
					success: true,
				};
				// console.log('<StoryFactory>getAll : ', retval);
				return retval;
			})
			.catch((reason) => {
				let retval: StoryList = {
					stories: [],
					success: false,
					reason: reason,
				};
				return retval;
			});
	}

	public static async getRecent() {
		return db.stories
			.toArray()
			.then(async (my_stories) => {
				let decorated = await Story.decorate(my_stories);
				decorated = decorated.sort(() => Math.random() - 0.5).slice(0,3 );
				let retval: StoryList = {
					stories: decorated,
					success: true,
				};
				// console.log('<StoryFactory>getRecent : ', retval);
				return retval;
			})
			.catch((reason) => {
				let retval: StoryList = {
					stories: [],
					success: false,
					reason: reason,
				};
				return retval;
			});
	}

	public static async query(query: StoryQuery) {
		// TODO : Query Not Implemented Yet
		const my_stories = await db.stories.toArray();
		const decorated = await Story.decorate(my_stories);
		let retval: StoryList = {
			stories: decorated,
			success: true,
		};
		return retval;
	}

	public static filter(poi_list: StoryList, query: StoryQuery) {
		const new_list = StoryFactory.getEmpty();

		new_list.query = query;
		new_list.success = true;

		if (query.filter !== undefined) {
			new_list.stories = poi_list.stories.filter((story) => {
				if (story.id) {
					let include_record = true;
					if (query.filter) {
						// Check for id match
						if (query.filter.id !== undefined) {
							if (!query.filter.id.includes(story.id)) {
								include_record = false;
							}
						}

						if (query.filter.title !== undefined) {
							const searchTarget = [];

							searchTarget.push(story.title);
							searchTarget.push(story.short_description);
							story.topics.map((topic) => {
								searchTarget.push(topic.title);
							});

							if (
								searchTarget
									.join(' ')
									.toLowerCase()
									.indexOf(
										query.filter.title.toLowerCase(),
									) === -1
							)
								include_record = false;
						}
					}
					return include_record;
				} else {
					return false;
				}
			});
		}
		return new_list;
	}
}
